import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import closeIcon from '../../../icons/icon/close.svg'
import { Modal, Container } from 'react-bootstrap'
import RecapchaComponent from 'react-google-recaptcha'
import { set, get, reset } from '../../../reducers/data.js'
import utils from '../../../utils/index.js'
import TextComponent from '../reusable/TextComponent.jsx'
import AcceptComponent from '../reusable/AcceptComponent.jsx'
import WaitAndThanks from '../layout/WaitAndThanks.jsx'
import SelectButtonComponent from '../dropdown/SelectButtonComponent.jsx'
import DsyButton from '../../../dsy-wrappers/dsy-button.js'
import { DsyIcon } from '../../../dsy-wrappers/dsy-icon.js'
import CAPComponeent from '../reusable/CAPComponeent.jsx'
import { DsyDivider } from '../../../dsy-wrappers/dsy-divider.js'
import useBreakpoint from "../../../custom-hooks/useBreakpoint.js";

import OcrFieldNote from '../../ocr/OcrFieldNote'



const isEmailValid = email => /^[\w-\.]+@([\w-]+\.)+[\w-]{2,5}$/gi.test(email)
const isPhoneValid = phone =>
  /^((00|\+)39[\. ]??)??3\d{2}[\. ]??\d{6,7}$/g.test(phone)

const ContactsModalComponent = ({ show, close, appointment }) => {
  const navigate = useNavigate()
  const createNewLead = async () => {
    try {
      setIsLoading(true)
      window.localStorage['Email'] = data.Email
      const res = await utils.sendLead(data)
      const link = document.querySelector('#download-link')
      link.href = res.ProjectUrl
      if (data["negozi"] !== true)
        link.click()

      dispatch(reset({}))
      navigate('/thanks')
      setIsLoading(false)
    } catch (e) {
      dispatch(
        set({
          cell: 'Error',
          value: e
        })
      )

      navigate('/thanks')
    }
  }

  const bp = useBreakpoint()
  const isDesktop = (bp ==="xxl" || bp ==="xl" || bp ==="lg")
  if (isDesktop) 
    document.querySelector("body").style.overflow = show ? "hidden" : "auto"

  const dispatch = useDispatch()
  const [invalidEmail, setInvalidEmail] = useState(false)
  const [invalidPhone, setInvalidPhone] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const data = useSelector(get)
  const negozi = data["negozi"]
  const tr = utils.testRendering
  let formComplete =
    data['Nome'] &&
    data['Cognome'] &&
    (negozi || data['Telefono']) &&
    // data['Email'] &&
    data["CAP"] && data["CAP"].length === 5 &&
    (!appointment || negozi || data['FasciaOraria']) &&
    (data['Privacy'] === true || negozi)&&
    data['Capcha']
  if (data['Email'] && data['Email'].length > 1) {
    if (!isEmailValid(data['Email'])) {
      formComplete = false
      // if (invalidEmail === false) setInvalidEmail(true)
    } else if (invalidEmail === true) setInvalidEmail(false)
    
  }

  if (data['Telefono'] && data['Telefono'].length > 8) {
    if (!isPhoneValid(data['Telefono'])) {
      formComplete = false
      // if (invalidPhone === false) setInvalidPhone(true)
    } else if (invalidPhone === true) setInvalidPhone(false)
  }
  

  if (data["Email"] === undefined || data["Email"]?.length === 0 && invalidEmail === true) setInvalidEmail(false)
  let label = 'CONFERMA' //appointment ? "LASCIA I TUOI CONTATTI" : "INVIA"
  if (isLoading) {
    return (
      <>
        <WaitAndThanks loading={true} fs={true} />
        <a
          style={{ display: 'none' }}
          href={data['ProjectUrl']}
          target='_blank'
          rel='noreferrer'
          download='report.pdf'
          id='download-link'
        ></a>
      </>
    )
  }

  const checkFields = () => { 
    if (data['Email'] && data['Email'].length > 1) {
      if (!isEmailValid(data['Email'])) {
        if (invalidEmail === false) setInvalidEmail(true)
      } else if (invalidEmail === true) setInvalidEmail(false)
    }
    if (data["Email"] === undefined || data["Email"].length === 0) setInvalidEmail(false)
  
    if (data['Telefono'] && data['Telefono'].length > 1) {
      if (!isPhoneValid(data['Telefono'])) {
        if (invalidPhone === false) setInvalidPhone(true)
      } else if (invalidPhone === true) setInvalidPhone(false)
    }

    if (data["Telefono"] === undefined || data["Telefono"].length === 0 || negozi) setInvalidPhone(false)
  }

  return (
    <Modal
      show={show}
      aria-modal="true"
      role="dialog"
      aria-label='Ricevi il report'
      centered={true}
      className='select-popup riepilogo contacts'
      animation={false}
      fullscreen={true}
      backdrop={false}
      
    >

     <div>
      <Container
        fluid
        className={'title d-flex justify-content-between align-items-center '  }
      >
        <div className='field-name'>
          {negozi ? "Concludi la simulazione e invia il report al cliente" : " Ricevi il report e prenota una consulenza"}
       
        </div>
        <div className='accent square-button' onClick={close} role="button">
          <img height={14} src={closeIcon} style={{marginRight:0}} alt="" role="presentation" />
        </div>
      </Container>
      <a
        style={{ display: 'none' }}
        href={data['ProjectUrl']}
        target='_blank'
        rel='noreferrer'
        download='report.pdf'
        id='download-link'
        aria-hidden={true}
      ></a>

        <div className='d-flex flex-column px-3'>
          <div className="f14 mt-3 mb-4">
            {negozi ?
            "Compila il form con i dati del nostro cliente per ottenere il report. Potrai inviarlo via email oppure stamparlo." : 
            "Compila il form per ricevere il report. Un nostro consulente ti ricontatterà al più presto per approfondire il tuo piano di risparmio"}
            </div>
          <div aria-hidden="true"><DsyDivider /></div>
          <div className="f14 mt-2 mb-4">I campi con * ci servono tutti, non lasciarli vuoti!</div>
          <div className="bold f16 mb-2">{negozi ? "Inserisci il suo CAP": "Inserisci il tuo CAP"}</div>
          <CAPComponeent />
          <OcrFieldNote field="CAP" extraClass="mb-3" />
          
          <div className="bold f16 mb-2">{negozi ? "Indica i suoi dati di contatto" : "Indica i tuoi dati di contatto"}</div>
          <TextComponent name='Nome*' cell='Nome' />
          <OcrFieldNote field="Nome" extraClass="mb-3" />
          
          <TextComponent name='Cognome*' cell='Cognome' />
          <OcrFieldNote field="Cognome" extraClass="mb-3" />
          
          <TextComponent isError={invalidPhone} name={negozi ? "Telefono" : 'Telefono*'} cell='Telefono' type='tel' onBlur={checkFields} />
          <div className={invalidPhone ? 'input-error' : "" } aria-live="polite">
            {invalidPhone && <> <DsyIcon name="danger" ></DsyIcon> <span className="ms-2"> Inserisci un numero di telefono valido</span></>}
          </div>
          
          <p className="f14 mb-2">{ negozi ? "Se il cliente desidera ricevere il report, inserisci la sua email.": "Se desideri ricevere il report, inserisci la tua email."}</p>
          <TextComponent isError={invalidEmail} name='Email' cell='Email' type='email' onBlur={checkFields} />
          <div className={ invalidEmail ? 'input-error' : ""} aria-live="polite">
            {invalidEmail &&<> <DsyIcon name="danger" ></DsyIcon> <span className="ms-2">  Inserisci un indirizzo email valido</span></>}
          </div>
        
          {appointment === true && !negozi === true && (
            <>
              <div className="bold f16 mb-0">
              In quale fascia oraria possiamo contattarti?
              </div>
              <SelectButtonComponent
                name='Seleziona la fascia oraria*'
                cell='FasciaOraria'
                choices={['Non ho preferenze', 'Mattina', 'Pomeriggio']}
                extraClass='fascia'
              />
            </>
          )}

          {!negozi && <AcceptComponent
            extraClass='border bold'
            type='check'
            name='Privacy Policy*'
            externalLink={'la privacy policy'}
            ariaLabel="Leggi l'Informativa Privacy, il collegamento apre in una nuova scheda"
            cell='Privacy'
            href='https://www.enel.it/it-it/assistenza/privacy'
          > 
          Ai sensi dell’art. 13 GDPR autorizzo Enel Energia, Titolare del trattamento, a contattarmi, entro 3 giorni lavorativi, per informazioni su offerte commerciali. Per il trattamento dei miei dati personali ho preso visione dell’ Informativa Privacy, disponibile qui. 
          </AcceptComponent> }
     

          <RecapchaComponent
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              margin: '16px 0'
            }}
            sitekey='6Lfq14UmAAAAAIlOFm2Vtd4lI5ng4V-eMImBFzKP'
            onExpired={() =>
              dispatch(
                set({
                  cell: 'Capcha',
                  value: false
                })
              )
            }
            onChange={(e) => {
              dispatch(
                set({
                  cell: 'Capcha',
                  value: true
                })
              )
              dispatch(
                set({
                  cell: 'Token',
                  value: e
                })
              )
            }
            }
          />
        </div>
        </div>
      <div className='w-100 end-button d-flex align-items-center align-items-lg-start justify-content-lg-between'>
        <div className="w-100 me-3">
          <DsyButton 
          id="cancel-button"
        tabIndex={0}
        label="Annulla"
        aria-label="Annulla"
        uppercase={false}
        full-width={true}  variant="secondary" shape="square"  onClick={close}>
          Annulla
        </DsyButton>
        </div>
        <div className="w-100">
        <DsyButton
          id="confirm-button"
          full-width={true}
          aria-label="Conferma"
          label="Conferma"
          disabled={!formComplete}
          shape="square"
          tabIndex={0}
          uppercase={false}
          onClick={createNewLead}
        >
          Conferma
        </DsyButton>
        </div>
      </div> 
    </Modal>
  )
}

export default ContactsModalComponent
